"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentTimestamp = exports.generateRandomNumber = exports.encryptString = void 0;
const crypto_js_1 = __importDefault(require("crypto-js"));
exports.encryptString = (input) => {
    return crypto_js_1.default.SHA1(input).toString();
};
function generateRandomNumber(max) {
    return Math.floor(Math.random() * max) + 1;
}
exports.generateRandomNumber = generateRandomNumber;
function currentTimestamp() {
    return Math.floor(Date.now() / 1000);
}
exports.currentTimestamp = currentTimestamp;
//# sourceMappingURL=oauth1-utils.js.map